import { Outlet } from "react-router-dom";

const ConferenceLayout = () => {
  return <Outlet />;
};

export default ConferenceLayout;
